import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { Blog } from "../../../../utils/apis/blog/Blog";
import { Context } from "../../../../utils/context";
import { IDS } from "../../../../utils/common";
import Blogs_card from "../../blogs_card/Blogs_card";
import "./Explore_Blogs.css";

const Explore_Blogs = () => {
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);
  const [exploreblog, setExploreBlog] = useState([]);

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const handleServiceClick = (id) => {
    navigate(`/blog/${id}`);
  };

  const getExploreBlog = async () => {
    try {
      const res = await Blog();
      if (res?.success) {
        setExploreBlog(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch explore blogs:", error);
    }
  };

  useEffect(() => {
    getExploreBlog();
  }, []);

  const topBlog = exploreblog.slice(0, 3);

  return (
    <section className="Explore_Blogs ">
      <div className="container">
        <h5 className="Explore_Blogs_header">Explore Blogs</h5>

        {/* Passed downstream structural context logic properties smoothly */}
        <Blogs_card 
          blog={topBlog} 
          handleServiceClick={handleServiceClick} 
          htmlToReactParser={htmlToReactParser} 
          IMG_URL={IMG_URL}
          IDS={IDS}
        />

        <div className="social_icons_div">
          <p>Follow us on :</p>
          <div className="footer_links">
            {[
              { icon: faFacebookF, link: "https://www.facebook.com" },
              { icon: faInstagram, link: "https://www.instagram.com" },
              {
                icon: faLinkedinIn,
                link: "https://www.linkedin.com",
              },
            ].map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="footer_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="icon_holder">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore_Blogs;